import React from 'react';
import { Box, Typography } from '@mui/material';
import { Product } from '../../types';
import ProductCard from '../common/ProductCard';

interface ProductGridProps {
  title?: string;
  products: Product[];
  onAddToCart: (product: Product) => void;
  onAddToWishlist: (product: Product) => void;
}

const ProductGrid: React.FC<ProductGridProps> = ({
  title,
  products,
  onAddToCart,
  onAddToWishlist
}) => {
  return (
    <Box>
      {title && (
        <Typography variant="h4" gutterBottom>
          {title}
        </Typography>
      )}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(4, 1fr)'
          },
          gap: { xs: 2, sm: 2.5, md: 3 }
        }}
      >
        {products.map((product) => (
          <ProductCard
            key={product._id}
            product={product}
            onAddToCart={onAddToCart}
            onAddToWishlist={onAddToWishlist}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ProductGrid;

